export const buildWebSecurityStatusData = https_status => ([{
    name: 'HTTPS',
    status: https_status
}]);
